import { useEffect, useState } from 'react'

/**
 * Delay a rapidly changing value.
 *
 * Used by the search box so typing does not fire a request per keystroke.
 */
export const useDebounced = <T,>(value: T, delayMs = 300): T => {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs)
    return () => window.clearTimeout(timer)
  }, [value, delayMs])

  return debounced
}
